<template>
  <div class="flexgrid">
    <div class="vertical-container">
      <Toast />
      <ConfirmPopup />
      <DynamicDialog />
      <RouterView />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss" scoped></style>
